import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              最受欢迎的高质量科普内容
            </p>
          </div>
          <Link
            to="/category/chaopen-yuanli"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className={`group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer ${
                idx === 0 ? 'md:col-span-3' : ''
              }`}
            >
              <div className={`flex ${idx === 0 ? 'flex-col md:flex-row' : 'flex-col'}`}>
                <div className={`${idx === 0 ? 'md:w-1/2' : 'w-full'} overflow-hidden`}>
                  <img
                    src={article.image}
                    alt={article.title}
                    className={`w-full object-cover object-top group-hover:scale-105 transition-transform duration-500 ${
                      idx === 0 ? 'h-52 md:h-64' : 'h-44'
                    }`}
                  />
                </div>
                <div className={`${idx === 0 ? 'md:w-1/2' : 'w-full'} p-5 md:p-6 flex flex-col justify-center`}>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                    <span>{article.date}</span>
                    <span>·</span>
                    <span>{article.readTime} 阅读</span>
                  </div>
                  <h3
                    className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 ${
                      idx === 0 ? 'text-lg md:text-xl' : 'text-base'
                    }`}
                  >
                    {article.title}
                  </h3>
                  <p className={`text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed ${
                    idx === 0 ? 'line-clamp-3' : 'line-clamp-2'
                  }`}>
                    {article.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/chaopen-yuanli"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}